import { Container, ContainerOptions, Text } from "pixi.js";
import GameConfig from "../GameConfig";
import gsap from "gsap";
import GlobalStore from "../services/GlobalStore";
import { CommonEvents } from "../events/EventEnums";
import {
  ControlledTextMap,
  TextCounterController,
} from "../services/TextCounterController";
import i18next from "i18next";
import { CurrentJackpotValue } from "../models/JackpotCurValue";

class CurrentJackpots extends Container {
  private jackpotTexts: ControlledTextMap = {};

  private showTimeline: gsap.core.Timeline | undefined;
  private hideTimeline: gsap.core.Timeline | undefined;

  constructor(containerOptions?: ContainerOptions) {
    super(containerOptions);

    const config = GameConfig.getInstance().config.current_jackpot;
    const fontFamily: string = "Avenir Next Condensed Demi Bold";

    console.log("CurrentJackpots config:", config);

    this.alpha = 0;

    for (const jpDef of config.jackpots) {
      console.log(jpDef);

      const jpText = new Text({
        text: "12345",
        style: {
          fontFamily: fontFamily,
          fontSize: jpDef.size,
          fill: jpDef.color,
          align: "center",
        },
      });
      jpText.x = jpDef.x;
      jpText.y = jpDef.y;
      jpText.anchor.set(0.5, 0.5);
      this.addChild(jpText);

      const jpController = new TextCounterController({
        attachTo: jpText,
        startingValue: 0,
        jackpotMode: true,
        duration: jpDef.spin_duration,
        delay: jpDef.delay_show,
        maxWidth: jpDef.max_width,
        formatter: (number) => {
          return new Intl.NumberFormat(i18next.language, {
            style: "currency",
            currency: "USD",
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }).format(number);
        },
      });

      // this.jackpotTexts[jpDef.id] = {
      //     text: jpText,
      //     controller: jpController,
      // };
      this.jackpotTexts[jpDef.id] = {
        text: jpText,
        controller: jpController,
      };
    }

    this.addEventListeners();
  }

  updateValues = (values: CurrentJackpotValue[]): void => {
    Object.keys(this.jackpotTexts).forEach((el) => {
      const v = values.find((it) => {
        return `${it.code}` === el;
      });

      if (v === undefined) return;

      const text = this.jackpotTexts[el];
      text.controller.countFromTo(text.controller.value(), v.value);
      // console.log("Started count", text.controller.value(), v.value);
    });
  };

  show = (delay: number = 0): void => {
    console.log("CurrentJackpots showing with delay", delay);

    if (this.hideTimeline) {
      this.hideTimeline.pause(0);
    }

    if (!this.showTimeline) {
      this.showTimeline = gsap.timeline();

      const optsStart = {
        alpha: 0,
      };

      const opts = {
        duration: 0.5,
        delay: delay,
        alpha: 1,
      };

      console.log("CurrentJackpots creating show timeline with options", opts);

      this.showTimeline.add([gsap.fromTo(this, optsStart, opts)]);
    }

    Object.keys(this.jackpotTexts).forEach((el) => {
      // console.log(el, id);
      const jpctrl = this.jackpotTexts[el].controller;
      jpctrl.countFromTo(jpctrl.endValue, jpctrl.endValue, 0);
    });

    this.showTimeline.play(0);
  };

  hide = (delay: number = 0): void => {
    console.log("CurrentJackpots hiding with delay", delay);

    if (!this.hideTimeline) {
      this.hideTimeline = gsap.timeline();

      const optsStart = {
        alpha: 1,
      };

      const opts = {
        duration: 0.5,
        delay: Math.max(0, delay - 0.5),
        alpha: 0,
      };

      console.log("CurrentJackpots creating hide timeline with options", opts);

      this.hideTimeline.add([gsap.fromTo(this, optsStart, opts)]);
    }

    this.hideTimeline.play(0);
  };

  hideInstant = (): void => {
    console.log("CurrentJackpots hideInstant()");
    if (this.alpha === 0) {
      return;
    }

    this.showTimeline?.pause(0);
    this.hideTimeline?.pause(0);

    this.alpha = 0;
  };

  private addEventListeners = () => {
    const commonEE = GlobalStore.commonEventEmitter;

    commonEE.on(CommonEvents.CHANGE_LANGUAGE, this.updateLanguage);
  };

  private removeEventListeners = () => {
    const commonEE = GlobalStore.commonEventEmitter;

    commonEE.off(CommonEvents.CHANGE_LANGUAGE, this.updateLanguage);
  };

  private updateLanguage = (): void => {
    console.log("CurrentJackpots updateLanguage()");
  };
}

export default CurrentJackpots;
